import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import Login from '../../component/login/login.js'
import ToastBar from '../../component/toast/toast.js'
import './welfare.css'
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import {getElementPosition} from '../../util.js'
import {getUnReadNum} from '../../redux/chatuser.redux.js'
import { Link} from "react-router-dom"
import {userList} from '../../redux/chatuser.redux.js'
import {getLoginURL} from '../../util.js'
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
@connect(
  state=>state.chatuser,
  {getUnReadNum,userList,getBigBGUrl}
)
class MyWelfare extends React.Component{
	constructor(props){
		super(props)
		 this.state={
     
	      showSelectWelfare:false,
	      visible:false,
	      showGetSuccess:false,
	      iTop:'',
	      getActives:'',
	      getActivesOff:true,
	      getClub:'',
	      getGoods:'',
	      getGoodsOff:true,
	      giftData:'',
	      key:1,
	      goodTotalPage:'',
	      activeTotalPage:''
   
	    }	
	    this.getActivesNum=2
	    this.getGoodsNum=3
	    this.getGoodsCallBack= this.getGoodsCallBack.bind(this)
	}

	componentDidMount(){
    
    	this.getClubList()
    	this.getActives()
    	this.getGoods()

  	}
  	getClubList(){
  		axios.get('fapi/user/club?page_index=1&limit=10')
	      .then(res=>{
	      	
	    	if(res.data.return_code==0){
	    		this.setState({
					getClub:res.data.data
				})
	    	}
     
	    })  
  		
  	}
  	getActives(){
  		const _this = this
  		axios.get('fapi/user/actives?limit=2&page_index=1')
	      .then(res=>{
	   
	      	if(res.data.return_code==0){
				this.setState({
					getActives:res.data.data,
					activeTotalPage:res.data.total_page
				})
	      	}
	    
     
	    })  
  	}
  	getGoodsCallBack(data){
  	
  		this.getGoods()
  	}
  	getGoods(){
  		const _this = this
  		////fapi/user/getGoods
  		
  		axios.get('/fapi/user/packs?limit=4&page_index=1')
	      .then(res=>{
	      
	      	if(res.data.return_code==0){
				this.setState({
					getGoods:res.data.data,
					goodTotalPage:res.data.total_page
				})
	      	}
	    
     
	    })  
  	}
  	
  	welfareAlert(e,idata){
  		/*
  		this.setState({
  			showSelectWelfare:true,
  			visible:false,
  			showGetSuccess:false,
  			iTop:getElementPosition(e.target).y+'px',
  			giftData:idata,
  			key:this.state.key+1
  		})*/
  		console.log(idata.game_id)
  		
  		this.props.history.push('/game-detail/'+idata.game_id)
  	}
  	goodsLoadMore(){
  		this.loadMore('packs','getGoods','getGoodsNum','getGoodsOff')
  	}
  	actLoadMore(){
  		
  		this.loadMore('actives','getActives','getActivesNum','getActivesOff')
  	}
  	loadMore(type,dataType,num,onOff){
  		
  		const iNum = this[num]

  		axios.get('fapi/user/'+type+'?limit=2&page_index='+iNum+'')
	      .then(res=>{
	       
	      	if(res.data.return_code==0){
	      		if(res.data.data.length!=0){
	      			var oData = this.state[dataType].concat(res.data.data) 
					
					this.setState({
						[dataType]:oData
					})
					if(this[num] >=res.data.total_page){
						
						this.setState({
							[onOff]:false
						})
					}
					
					this[num] = this[num]+1

	      		}
	      		if(res.data.data.length==0){
	      			this.setState({
							[onOff]:false
					})
	      		}
	      	}
	     
	    })  
  		
		
  	}
  	render(){
  		this.props.userlist.code?()=>getLoginURL(this.props.location.pathname):null 
  		
		return (
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>
				<HeaderBar></HeaderBar>
				
				<div className="my-welfare-box">
					<Login showLogin={this.props.showLogin}>
		               
		            </Login>
					
					<div className="my-welfare-con">
						<div className="my-welfare my-power" style={this.state.getClub.length===0?{"display":"none"}:{"display":"block"}}>

							<h6><i></i>我的游戏福利</h6>
							<ul className="clearfix">
								{
									this.state.getClub&&this.state.getClub.map((item,i)=>{

										return (
											<li key={i}>
												<div className="left" style={{backgroundImage:"url("+item.game_img+")"}}></div>
												<div className="right">
													<span>{item.game_name}</span>
													<div className="gift-name"><i>{item.level}</i>礼包</div>
													<a href={item.game_linkurl} target="_blank"></a>
												</div>
											</li>
										)
									})
								}
								

							</ul>
						</div>

						<div className="my-gift my-power" style={this.state.getGoods.length===0?{"display":"none"}:{"display":"block"}}>

							<h6><i></i>我的特权礼包</h6>
							<ul className="clearfix">
								{this.state.getGoods&&this.state.getGoods.map((item,i)=>{
									return (
										<li key={i}>
											<div className="left" style={{backgroundImage:"url("+item.good_img+")"}}></div>
											<div className="right">

												<span>{item.gamename}</span>
												<div className="gift-name welfare-gift"><i>{item.title}</i></div>
												{
													item.can_receive===2?<button className="goods-received">已领取</button>:
													<button  onClick={(e)=>this.welfareAlert(e,item)}></button>
												}
												
											</div>
										</li>
									)
								})}
								
								


							</ul>
							{this.state.getGoodsOff&&this.state.goodTotalPage>1&&<a className="check-more" onClick={()=>this.goodsLoadMore()}>加载更多</a>}
						</div>
						<div className="my-active my-power">

							<h6><i></i>我的会员活动</h6>
							<ul className="clearfix">
								{
									this.state.getActives&&this.state.getActives.map((item,i)=>{

										return (
											<li key={i}>
												<div className="left" style={{background:"url("+item.active_url+")"}}>
													<a href={item.linkurl} target="_blank"></a>
												</div>


												<div className="right">
													<span>{item.title}</span>
													
													<strong>{item.diffday}天后结束</strong>
												</div>
											</li>
										)
									})

								
								}
								


							</ul>
							{this.state.getActivesOff&&this.state.activeTotalPage>1&&<a className="check-more" onClick={()=>this.actLoadMore()}>加载更多</a>}
						</div>



					</div>
					<LeftNav 
						myTitle="个人中心"						
						optData={["","left-nav-active","my-message-btn"]}
						childData={["我的会员","我的福利","我的消息"]}
					>
					
					</LeftNav>
					
				</div>
				<GiftAlert 
					key={this.state.key}
					showSelectWelfare={this.state.showSelectWelfare}
					visible={this.state.visible}
					showGetSuccess={this.state.showGetSuccess}
					iTop={this.state.iTop}
				//giftData={this.state.giftData||''}
					giftData={{'id':this.state.giftData.good_id}||''}
					packId={this.state.giftData.id}
					getSuccessCallBack={this.getGoodsCallBack}
				></GiftAlert>
						
			</div>
		)
  	}
}

export default MyWelfare


// WEBPACK FOOTER //
// ./src/container/center-welfare/welfare.js